import { usePageLinks } from './usePageLinks'
import { useLanguage } from '../context/LanguageContext'

export const usePageLink = (key) => {
  const { lang } = useLanguage()
  const slugMap = usePageLinks()

  return slugMap[key]?.[lang] || { uri: '/', title: key }
}
